import React from "react";
import { ScrollText, ArrowLeft } from "lucide-react";

/**
 * Termos de Uso e Politica de Privacidade da ClickHub - achado da
 * varredura: nao existia nenhum registro de consentimento no sistema,
 * o que e um risco juridico real (LGPD exige consentimento explicito e
 * registrado para tratamento de dados pessoais).
 *
 * NOTA HONESTA: este texto foi escrito com base nas regras de negocio
 * ja confirmadas no sistema (garantia, repasse, certificado digital,
 * planos). Recomenda-se revisao por um advogado antes de operar em
 * volume real - isto nao substitui aconselhamento juridico profissional.
 */
const TermosDeUso = ({ onVoltar }) => {
  return (
    <div className="min-h-screen bg-gray-950 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        {onVoltar && (
          <button onClick={onVoltar} className="flex items-center gap-2 text-gray-400 hover:text-white text-sm mb-6">
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </button>
        )}

        <div className="flex items-center gap-3 mb-6">
          <ScrollText className="w-7 h-7 text-orange-400" />
          <h1 className="text-2xl font-bold text-white">Termos de Uso e Política de Privacidade</h1>
        </div>

        <div className="space-y-6 text-sm text-gray-300 leading-relaxed">
          <p className="text-xs text-gray-500">Última atualização: agosto de 2026</p>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">1. O que é a ClickHub</h2>
            <p>
              A ClickHub é uma plataforma de intermediação que conecta fornecedores, afiliados e marketplaces.
              O fornecedor cadastra produtos, o afiliado escolhe o que divulgar e vende nos marketplaces
              conectados, e a ClickHub processa o repasse entre as partes.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">2. Cadastro e Conta</h2>
            <p>
              Você é responsável pela veracidade dos dados informados no cadastro (nome, e-mail, CPF/CNPJ,
              telefone) e pela segurança da sua senha. Contas de administrador/colaborador só são criadas
              pelo dono da plataforma - nunca por autocadastro.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">3. Garantia e Repasse (Afiliado)</h2>
            <p>
              Ao vincular um produto para venda, o valor de custo é reservado ("garantia") no seu saldo
              disponível na plataforma. Esse valor só é liberado ao fornecedor após a confirmação de entrega
              pelo administrador. Sem saldo suficiente, o produto não pode ser publicado.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">4. Certificado Digital</h2>
            <p>
              Fornecedores e afiliados têm um prazo de 7 dias, a partir do cadastro, para enviar o certificado
              digital (A1). Sem isso, a conta fica bloqueada até o envio - essa exigência existe para viabilizar
              a emissão de nota fiscal das operações realizadas na plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">5. Planos e Cobrança</h2>
            <p>
              O acesso à plataforma depende de um plano ativo (Iniciante, Universal ou Diamante Brasil), com
              valores e limites de marketplaces específicos de cada plano. O modo automático 24/7 é uma
              funcionalidade adicional, concedida individualmente pelo administrador mediante solicitação.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">6. Privacidade e Dados Pessoais (LGPD)</h2>
            <p>
              Coletamos os dados necessários para operar sua conta: nome, e-mail, telefone, CPF/CNPJ,
              certificado digital, e dados de vendas/repasses. Esses dados são usados exclusivamente para
              o funcionamento da plataforma (autenticação, processamento de pedidos, repasses, emissão de
              nota fiscal) e não são vendidos a terceiros.
            </p>
            <p className="mt-2">
              Você pode solicitar a qualquer momento, pelo suporte, a exclusão ou exportação dos seus dados,
              respeitados os prazos legais de guarda de documentos fiscais e financeiros.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">7. Cancelamento e Reembolso</h2>
            <p>
              Pedidos com repasse já autorizado ao fornecedor não podem ser cancelados diretamente pelo
              afiliado - nesse caso, abra uma solicitação de estorno pelo suporte, que será analisada
              individualmente.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">8. Contato</h2>
            <p>
              Dúvidas sobre estes termos ou sobre seus dados pessoais podem ser enviadas pelo suporte da
              plataforma.
            </p>
          </section>

          <p className="text-xs text-gray-600 pt-4 border-t border-gray-800">
            Este documento é gerenciado internamente pela ClickHub e pode ser atualizado. Alterações
            relevantes serão comunicadas aos usuários ativos.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermosDeUso;
